
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as app0wR_K4EEZ6vYDujdBnz2mDKGP73Ndz2HWYkUKcBgf30Meta } from "/opt/build/repo/pages/app.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as index1dTy64Xfzf68oRrazQeANY5wSaCawrizPxQOk7k5ITkMeta } from "/opt/build/repo/pages/cgu/index.vue?macro=true";
import { default as indexbf9GgBYlDr166merohaW6l54mGuIZ0Wi0Swawj1_9rYMeta } from "/opt/build/repo/pages/blog/index.vue?macro=true";
import { default as indexw8hGJRVV3c7n0g7k7xOAhBoVAltRlLGcHFoIfHSaxLgMeta } from "/opt/build/repo/pages/rgpd/index.vue?macro=true";
import { default as indexOFmwl2U90UoPUmT_1LwuosWahGBb8frwU_p7addqftkMeta } from "/opt/build/repo/pages/legal/index.vue?macro=true";
import { default as index_6gCGc5xXjJftP7cuqj6WT0hyHnthwjjLsMt4_8ADggMeta } from "/opt/build/repo/pages/compte/index.vue?macro=true";
import { default as _91_46_46_46slug_93i2sVrXiInXdXOfqivOHLmhnCST__45wiae2OFaLgA_45yY4Meta } from "/opt/build/repo/pages/blog/[...slug].vue?macro=true";
import { default as indexLOWqJcFkcbfluUiXmjnPwTQsqMROvupPv5d5Dty_45Ih4Meta } from "/opt/build/repo/pages/contrats/index.vue?macro=true";
import { default as index5W9QzZ_45KTA7p9G7JVeSzlYndMlSQgAeHIhExlBI0TBoMeta } from "/opt/build/repo/pages/abonnement/index.vue?macro=true";
import { default as indexSGm7Rbgk6z58RXYxfIn2Zig8vbTOO5z1VSr5BmowepcMeta } from "/opt/build/repo/pages/integrations/index.vue?macro=true";
import { default as _91uuid_93gZMlNaHZ1vef_jQSzV7mi06b5SEk5nik43UUpKCiXcYMeta } from "/opt/build/repo/pages/cra/validate/[uuid].vue?macro=true";
export default [
  {
    name: "app",
    path: "/app",
    meta: app0wR_K4EEZ6vYDujdBnz2mDKGP73Ndz2HWYkUKcBgf30Meta || {},
    component: () => import("/opt/build/repo/pages/app.vue")
  },
  {
    name: "landing",
    path: "/",
    meta: indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "cgu",
    path: "/cgu",
    meta: index1dTy64Xfzf68oRrazQeANY5wSaCawrizPxQOk7k5ITkMeta || {},
    component: () => import("/opt/build/repo/pages/cgu/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexbf9GgBYlDr166merohaW6l54mGuIZ0Wi0Swawj1_9rYMeta || {},
    component: () => import("/opt/build/repo/pages/blog/index.vue")
  },
  {
    name: "rgpd",
    path: "/rgpd",
    meta: indexw8hGJRVV3c7n0g7k7xOAhBoVAltRlLGcHFoIfHSaxLgMeta || {},
    component: () => import("/opt/build/repo/pages/rgpd/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: indexOFmwl2U90UoPUmT_1LwuosWahGBb8frwU_p7addqftkMeta || {},
    component: () => import("/opt/build/repo/pages/legal/index.vue")
  },
  {
    name: "compte",
    path: "/compte",
    meta: index_6gCGc5xXjJftP7cuqj6WT0hyHnthwjjLsMt4_8ADggMeta || {},
    component: () => import("/opt/build/repo/pages/compte/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    meta: _91_46_46_46slug_93i2sVrXiInXdXOfqivOHLmhnCST__45wiae2OFaLgA_45yY4Meta || {},
    component: () => import("/opt/build/repo/pages/blog/[...slug].vue")
  },
  {
    name: "contrats",
    path: "/contrats",
    meta: indexLOWqJcFkcbfluUiXmjnPwTQsqMROvupPv5d5Dty_45Ih4Meta || {},
    component: () => import("/opt/build/repo/pages/contrats/index.vue")
  },
  {
    name: "abonnement",
    path: "/abonnement",
    meta: index5W9QzZ_45KTA7p9G7JVeSzlYndMlSQgAeHIhExlBI0TBoMeta || {},
    component: () => import("/opt/build/repo/pages/abonnement/index.vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    meta: indexSGm7Rbgk6z58RXYxfIn2Zig8vbTOO5z1VSr5BmowepcMeta || {},
    component: () => import("/opt/build/repo/pages/integrations/index.vue")
  },
  {
    name: "cra-validate-uuid",
    path: "/cra/validate/:uuid()",
    component: () => import("/opt/build/repo/pages/cra/validate/[uuid].vue")
  }
]